export default __webpack_public_path__ + "static/media/indogo-screenshot-06.9ce69a27.png";